module.exports = __webpack_public_path__ + "img/temp3.7f6d24a0.svg";